import React from "react";
import ReactDOM from "react-dom/client";
import "./brands/miactivo/colors.css";
import { loadLocalization } from "locale";
import "react-datepicker/dist/react-datepicker.css";
import Providers from "./Providers";
import Router from "./Router";
import ErrorBoundary from "./module/common/component/ErrorBoundary/ErrorBoundary";
import "./module/api/OpenApiConfig";
import { ApiError } from "module/api/service";
import { initPostHog } from "utils/posthog";
loadLocalization();
initPostHog();

// Глобальна обробка необроблених помилок промісів
window.addEventListener("unhandledrejection", (event) => {
    // Ігноруємо 404 помилки, оскільки вони очікувані (наприклад, коли користувач не залогінений)
    if (event.reason instanceof ApiError && event.reason.status === 404) {
        event.preventDefault(); // Запобігаємо виводу помилки в консоль
        // eslint-disable-next-line no-console
        console.debug("Unhandled 404 (expected):", event.reason.url);
        return;
    }
    // Для інших помилок залишаємо стандартну обробку
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <ErrorBoundary>
            <Providers>
                <Router />
            </Providers>
        </ErrorBoundary>
    </React.StrictMode>,
);
